import React, { Component } from 'react'
import { Icon, Modal, Button, Table, Header, Menu } from 'semantic-ui-react'

const { breakdownOfFees, tuitionFeeSched } = require('../../constants')

class SchoolYearsFees extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      activeTab: 'breakdown',
    };
  }

  closeModal = () => this.setState({ showModal: false })
  openModal = () => this.setState({ showModal: true })

  renderBreakdownTable() {
    return (
      <div style={{ overflowX: 'auto' }}>
        <Table celled striped compact size='small' textAlign='center'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Grade Level</Table.HeaderCell>
              <Table.HeaderCell>Tuition</Table.HeaderCell>
              <Table.HeaderCell>Misc</Table.HeaderCell>
              <Table.HeaderCell>Books</Table.HeaderCell>
              <Table.HeaderCell>Total</Table.HeaderCell>
              <Table.HeaderCell>Subsidy</Table.HeaderCell>
              <Table.HeaderCell>Grand Total</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {breakdownOfFees.map((fee, index) => (
              <Table.Row key={index}>
                <Table.Cell textAlign='left'><strong>{fee.gradeLevel}</strong></Table.Cell>
                <Table.Cell>{fee.tuition}</Table.Cell>
                <Table.Cell>{fee.misc}</Table.Cell>
                <Table.Cell>{fee.books || '--'}</Table.Cell>
                <Table.Cell>{fee.total}</Table.Cell>
                <Table.Cell>{fee.subsidy || '--'}</Table.Cell>
                <Table.Cell positive><strong>{fee.grandTotal}</strong></Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </div>
    )
  }

  renderTuitionScheduleTable() {
    return (
      <div style={{ overflowX: 'auto' }}>
        <Table celled striped compact size='small' textAlign='center'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell rowSpan='2'>Grade Level</Table.HeaderCell>
              <Table.HeaderCell rowSpan='2'>Cash</Table.HeaderCell>
              <Table.HeaderCell colSpan='2'>Semi-Annual</Table.HeaderCell>
              <Table.HeaderCell colSpan='2'>Quarterly</Table.HeaderCell>
              <Table.HeaderCell colSpan='2'>Monthly</Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              <Table.HeaderCell>Upon Enrollment</Table.HeaderCell>
              <Table.HeaderCell>Balance</Table.HeaderCell>
              <Table.HeaderCell>Upon Enrollment</Table.HeaderCell>
              <Table.HeaderCell>Balance</Table.HeaderCell>
              <Table.HeaderCell>Upon Enrollment</Table.HeaderCell>
              <Table.HeaderCell>Monthly</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {tuitionFeeSched.map((fee, index) => (
              <Table.Row key={index}>
                <Table.Cell textAlign='left'><strong>{fee.gradeLevel}</strong></Table.Cell>
                <Table.Cell>{fee.cash}</Table.Cell>
                <Table.Cell>{fee.uponEnrollmentSemi}</Table.Cell>
                <Table.Cell>{fee.semi}</Table.Cell>
                <Table.Cell>{fee.uponEnrollmentQuarterly}</Table.Cell>
                <Table.Cell>{fee.quarterly}</Table.Cell>
                <Table.Cell>{fee.uponEnrollmentMonthlyPlusBooks}</Table.Cell>
                <Table.Cell>{fee.monthly}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </div>
    )
  }

  render() {
    const { activeTab } = this.state;

    return (
      <Modal
        trigger={
          <Button icon labelPosition='left' color='teal' onClick={this.openModal}>
            <Icon name='money bill alternate outline' />
            Tuition Fees
          </Button>
        }
        open={this.state.showModal}
        onClose={this.closeModal}
        closeIcon
        size='large'
      >
        <Modal.Header>
          <Icon name='money bill alternate outline' /> Tuition Fee Schedule
        </Modal.Header>
        <Modal.Content scrolling>
          <Menu tabular>
            <Menu.Item
              name='Breakdown of Fees'
              active={activeTab === 'breakdown'}
              onClick={() => this.setState({ activeTab: 'breakdown' })}
            />
            <Menu.Item
              name='Payment Schedule'
              active={activeTab === 'schedule'}
              onClick={() => this.setState({ activeTab: 'schedule' })}
            />
          </Menu>

          {activeTab === 'breakdown' && (
            <div>
              <Header as='h4' color='grey'>Fee breakdown per grade level (Tuition + Miscellaneous + Books)</Header>
              {this.renderBreakdownTable()}
            </div>
          )}

          {activeTab === 'schedule' && (
            <div>
              <Header as='h4' color='grey'>Payment options per grade level (Cash, Semi-Annual, Quarterly, Monthly)</Header>
              {this.renderTuitionScheduleTable()}
            </div>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.closeModal}>Close</Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

export default SchoolYearsFees
